import { CompaniesSubscriptionOverload, ItemModuleFragment } from 'generated/resources/graphql'
import moment from 'moment'

import { stringToDate } from 'modules/core/lib/dates'

export const getTrialRemainingDays = (
  activeSubscriptionOverload?: Omit<CompaniesSubscriptionOverload, 'companyId'>
) => {
  if (!activeSubscriptionOverload) return null
  const endDate = stringToDate(activeSubscriptionOverload.expirationDate, 'backend')
  const now = moment()
  return endDate.diff(now, 'days') + 1
}

export const findModuleNameById = (module: ItemModuleFragment, moduleIds?: string[]) => {
  if (!module.chargebeeModuleId || !moduleIds) return null
  const moduleName = moduleIds.includes(module.chargebeeModuleId) ? module.translatedName : null
  return moduleName ? moduleName : null
}
